import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Settings from './pages/Settings';
import CalendarPage from './pages/Calendar';
import Goals from './pages/Goals';
import FocusAndLearn from './pages/FocusAndLearn';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import { useAuth } from './contexts/AuthContext';
import Profile from './pages/Profile';
import Curricula from './pages/Curricula';
import CurriculumDetail from './pages/CurriculumDetail';
import CurriculumCourseDetail from './pages/CurriculumCourseDetail';

// Protected Route component
function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  return currentUser ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/app"
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="curricula" element={<Curricula />} />
              <Route path="curricula/:curriculumId" element={<CurriculumDetail />} />
              <Route path="curricula/:curriculumId/courses/:courseId" element={<CurriculumCourseDetail />} />
              <Route path="calendar" element={<CalendarPage />} />
              <Route path="goals" element={<Goals />} />
              <Route path="focus" element={<FocusAndLearn />} />
              <Route path="settings" element={<Settings />} />
              <Route path="profile" element={<Profile />} />
            </Route>
          </Routes>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App; 